// extracted by mini-css-extract-plugin
export default {"container":"HeaderContainer-module--container--kfhdu"};